<template>
  <page layout="tabbed">
    <page-header-new :breadcrumbs="breadcrumbs" :title="pageTitle">
      <template slot="actions">
        <el-button
          v-show="!readonly && $route.name === 'IntegrationsList'"
          type="primary"
          @click="goToMarketplace"
        >
          {{ $t('Integrations_Button_CreateIntegration') }}
        </el-button>
      </template>
    </page-header-new>

    <page-tabs :tabs="tabs"></page-tabs>
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageTabs from '@/common/components/page/PageTabs'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import { projectRoute } from '@/core/helpers'

export default {
  name: 'IntegrationsPage',

  components: {
    Page,
    PageTabs,
    PageHeaderNew
  },

  computed: {
    pageTitle() {
      return (
        this.$store.getters.embeddedTitle ||
        this.$t('Integrations_Title_Portal')
      )
    },

    breadcrumbs() {
      return [
        {
          label: this.$t('Integrations_Breadcrumb_Settings')
        },
        {
          label: this.$t('Integrations_Breadcrumb_Integrations')
        }
      ]
    },

    tabs() {
      return [
        {
          title: this.$t('Integrations_Tab_ConfiguredIntegrations'),
          route: projectRoute({
            name: 'IntegrationsList'
          })
        },
        {
          title: this.$t('Integrations_Tab_Marketplace'),
          route: projectRoute({
            name: 'IntegrationsMarketplace'
          })
        }
      ]
    },

    readonly() {
      return !this.$can('manageProjectTechnical')
    }
  },

  methods: {
    goToMarketplace() {
      this.$router.push(
        projectRoute({
          name: 'IntegrationsMarketplace'
        })
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/pages/IntegrationsPage.vue